import {
  Button,
  HStack,
  Stack,
  StackSeparator,
  Text,
  VStack,
} from "@chakra-ui/react";
import { t } from "i18next";
import { StmAttributeChange } from "./components/StmAttributeChange";
import { Treatment } from "../../../osaway/models/OsaNode";
import { TreatmentScoreBubble } from "../../../coding/views/TreatmentScoreBubble";
import { CustomDialog } from "../CustomDialog";

interface Props {
  treatments: Treatment[];
  onClose: () => void;
}
export const NodeTreatmentsModal: React.FC<Props> = ({
  treatments,
  onClose,
}) => {
  return (
    <CustomDialog
      size="xl"
      onClose={onClose}
      header={t("map:treatments.title")}
      footer={
        <Button colorPalette="primary" onClick={onClose}>
          {t(`shared:close`)}
        </Button>
      }
    >
      <Stack gap={8}>
        {treatments.map((treatment) => (
          <HStack key={treatment.type} gap={4} separator={<StackSeparator />}>
            <VStack w={20} flexShrink={0}>
              <Text fontSize="xs" textAlign="center">
                {t("map:treatments.scoreIfApplied")}
              </Text>
              <TreatmentScoreBubble score={treatment.score} />
            </VStack>
            <Stack>
              <Text fontSize="md" fontWeight="semibold">
                {t(`sdk:treatments.${treatment.type}`)}
              </Text>
              <Text fontSize="sm" textAlign="justify">
                {t(`sdk:treatments.description.${treatment.type}`)}
              </Text>
              <Text fontSize="sm" textAlign="justify">
                {t("map:treatments.modelOutcome")}
              </Text>
              <HStack>
                <StmAttributeChange treatmentType={treatment.type} />
              </HStack>
            </Stack>
          </HStack>
        ))}
      </Stack>
    </CustomDialog>
  );
};
